import React from 'react'
import PixelV2Handler from './PixelV2Handler'
import Config from './Config'
import { VERSION } from './constants'

interface ADSHandlerProps {
  userId?: number
  versions: { v1?: boolean; v2?: boolean }
  mania: VERSION
}

const ADSHandler: React.FC<ADSHandlerProps> = ({ userId, mania, versions: { v1, v2 } }) => {
  Config.set({ v1, v2, mania })

  if (v2) return <PixelV2Handler userId={userId} mania={mania} />

  return null
}

export default ADSHandler
